<template>
<div class="">
    <div class=" backgroundcolor2 borderadius12 ml-3 mr-3 mb-3">
        <div class="card-body text-center pt-5 pb-5">
            <div class="p-5 d-flex flex-column text-center" v-if="companyProfileId">
                <img src="../assets/no_video.svg" alt="nojobs" class="img-fluid no-video pl-5 pr-5 pb-4 mx-auto">
                <span class="proximanova-thin fontsize24 black60" v-if="joberrorcode=='1050'">You Don't have an access to this Job.</span>
                <span class="proximanova-thin fontsize24 black60" v-if="joberrorcode=='1021'">No Job record found with selected job id.</span>
            </div>
            <div class="p-5 d-flex flex-column text-center" v-else>
                <img src="../assets/no_video.svg" alt="nojobs" class="img-fluid no-video pl-5 pr-5 pb-4 mx-auto">
                <span class="proximanova-thin fontsize24 black60">To access these screens (or) functionality you should create your profile first.</span>
                <button class="postingVideo proximanova btn btn-default mt-4 p-1 mx-auto" @click="NavToCreateProfile">Create Profile</button>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import router from '../router.js'
import sessionUtils from '../js/session-util.js'
import wndata from '../js/wn_data.json'
export default {
    data(){
        return{
            companyProfileId : null,
            module : '',
        }
    },
    props:[
        'joberrorcode'
    ],
    mounted(){
        let value = sessionUtils.getCompanyProfileId();
        if(value != 'null' && value != 'undefined'){
        this.companyProfileId = value;
        }
        this.module = sessionUtils.getmodule();
    },
    methods : {
        NavToCreateProfile : function() {
            if(this.module == 'Recruiter'){
                router.push({
                    name : 'createprofile'
                })
            }else{
                var x = document.createElement('a')
                x.target = '_blank'
                x.href = wndata.companyAccountWebappCreate;
                x.click()
            }
        }
    }
}
</script>
<style scoped>
.postingVideo {
  cursor: pointer; 
  text-align: center;
  border-radius: 16px;
  width: 140px;
  background-color: black;
  color: white !important;
  transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1
}
.postingVideo::before {
	transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 20px;
	background-color :  rgba(255,255,255,.3);
}
.postingVideo:hover:before {
	transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
}
/* @media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5%;
    padding-right: 5%;
  }
} */
</style>